import { render, staticRenderFns } from "./Onetime.vue?vue&type=template&id=617af6cd&"
import script from "./Onetime.vue?vue&type=script&lang=js&"
export * from "./Onetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports